// components/TabMenuPanel.jsx
import { Paper, Stack, Button } from "@mui/material";

export const TabMenuPanel = ({ items, activeId, onTabChange }) => (
  <Paper elevation={3} sx={{ p: 2, minWidth: 200 }}>
    <Stack spacing={1}>
      {items.map((item) => (
        <Button
          key={item.id}
          variant={activeId === item.id ? "contained" : "outlined"}
          fullWidth
          onClick={() => onTabChange(item.id)}
          sx={{ justifyContent: "flex-start" }}
        >
          {item.label}
        </Button>
      ))}
    </Stack>
  </Paper>
);
